// type predicate to help identify rejected payloads from backend.
export function isFSA(action) {
    try {
        return typeof action === "object" && action !== null && "type" in action && "payload" in action;
    }
    catch (_a) {
        return false;
    }
}
// FetchBaseQuery error
export function isErrorResult(result) {
    return typeof result === "object" && result !== null && "error" in result;
}
export function isApiResponse(data) {
    return typeof data === "object" && data !== null && "payload" in data && "type" in data;
}
export function isApiError(data) {
    return typeof data === "object" && data !== null && "error" in data && data.error === true;
}
export function hasCsrfToken(data) {
    return (typeof data.payload === "object" &&
        data.payload !== null &&
        "csrf_token" in data.payload &&
        typeof data.payload.csrf_token === "string");
}
